























import {Component, Prop, Vue} from 'vue-property-decorator';
import Meter from '@/data/models/meter';

@Component({})
export default class DetailComponent extends Vue {
  @Prop({required: true})
  meterId: string;

  meter: Meter = null;

  mounted(): void {
    this.$store.commit("showLoader", true);
    this.$dao.meters
      .getById(this.meterId)
      .then((result) => {
          if (result != null) {
            this.meter = result;
          }
        },
      )
      .finally(() => this.$store.commit("showLoader", false));
  }
}
